export default __webpack_public_path__ + "static/media/diceLogo.6d96fa35.jpg";